import { useEffect } from 'react';

const carriesFiles = (e: DragEvent) => Boolean(e.dataTransfer?.types.includes('Files'));

/**
 * While mounted, a file dropped anywhere outside the drop target does nothing, instead of the
 * browser opening it and leaving the page.
 */
export function useWindowDropGuard() {
  useEffect(() => {
    const stop = (e: DragEvent) => {
      if (carriesFiles(e)) e.preventDefault();
    };
    window.addEventListener('dragover', stop);
    window.addEventListener('drop', stop);
    return () => {
      window.removeEventListener('dragover', stop);
      window.removeEventListener('drop', stop);
    };
  }, []);
}
